import { IAuthenticationProvider, AuthEnvironment } from "../interfaces/IAuthenticationProvider"
import { DODAuthenticationProvider } from "../office-js/auth/DODAuthenticationProvider";
import { GCCAuthenticationProvider } from "../office-js/auth/GCCAuthenticationProvider";
import { GCCHAuthenticationProvider } from "../office-js/auth/GCCHAuthenticationProvider";
import { PpeAuthenticationProvider } from '../office-js/auth/PpeAuthenticationProvider'
import { ProdAuthenticationProvider } from "../office-js/auth/ProdAuthenticationProvider";
import { USNATAuthenticationProvider } from "../office-js/auth/USNATAuthenticationProvider";
import { USSECAuthenticationProvider } from "../office-js/auth/USSECAuthenticationProvider";
import { MSITAuthenticationProvider } from "../office-js/auth/MSITAuthenticationProvider";

export const CreateAuthenticationProvider = (environment: AuthEnvironment = AuthEnvironment.PPE) : IAuthenticationProvider => {
    switch (environment) {
        case AuthEnvironment.PPE:
            return new PpeAuthenticationProvider();
        case AuthEnvironment.Prod:
            return new ProdAuthenticationProvider();
        case AuthEnvironment.GCC:
            return new GCCAuthenticationProvider();
        case AuthEnvironment.GCCHigh:
            return new GCCHAuthenticationProvider();
        case AuthEnvironment.DOD:
           return new DODAuthenticationProvider();
        case AuthEnvironment.USNAT:
            return new USNATAuthenticationProvider();
        case AuthEnvironment.USSEC:
            return new USSECAuthenticationProvider();
        case AuthEnvironment.MSIT:
            return new MSITAuthenticationProvider();
        default:
            throw new Error("Unknown AuthEnvironment: " + environment);
    }
}